import React, {FC} from 'react';

import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {OnMentionClick} from '../../../../../../srcCommon/formatters/markdown/transforms/commonMarkdownTransformMentions';
import {CommentBody, CommentBodyProps} from './commentBody';
import {CommentViewerUnfurls} from './commentViewerUnfurls';

/*
 * Props + Types.
 */

export interface CommentBodyUnfurlsProps extends CommentBodyProps {
  panelId: ViewerPanelId;
  onMentionClick?: OnMentionClick;
}

export const CommentBodyWithUnfurls: FC<CommentBodyUnfurlsProps> = (props) => {
  const {
    panelId,
    comment,
    annotations,
    attachments,
    referencedAuthor,
    referencedComment,
    referencedRecipient,
    mentionableAliases,
    userAlias,
    shouldAlwaysUseMultiAttachmentStyle,
    shouldHideAnnotation,
    onReferencedActivityClick,
    onMentionClick,
    renderOneBigEmoji,
    renderCommentMarkdown,
    renderImageAttachments,
    isInteractionDisabled,
    noMargin,
    noPadding,
    isReferencingTheSameMessageAsPrevious,
    namespace,
    shouldTruncateAnnotationText,
    textWrapper,
    isJumpPointerDisabled,
  } = props;

  return (
    <CommentBody
      comment={comment}
      annotations={annotations}
      attachments={attachments}
      referencedAuthor={referencedAuthor}
      referencedComment={referencedComment}
      referencedRecipient={referencedRecipient}
      mentionableAliases={mentionableAliases}
      userAlias={userAlias}
      shouldAlwaysUseMultiAttachmentStyle={shouldAlwaysUseMultiAttachmentStyle}
      shouldHideAnnotation={shouldHideAnnotation}
      onReferencedActivityClick={onReferencedActivityClick}
      onMentionClick={onMentionClick}
      renderOneBigEmoji={renderOneBigEmoji}
      renderCommentMarkdown={renderCommentMarkdown}
      renderImageAttachments={renderImageAttachments}
      isReferencingTheSameMessageAsPrevious={isReferencingTheSameMessageAsPrevious}
      isInteractionDisabled={isInteractionDisabled}
      noMargin={noMargin}
      noPadding={noPadding}
      shouldTruncateAnnotationText={shouldTruncateAnnotationText}
      namespace={namespace}
      textWrapper={textWrapper}
      isJumpPointerDisabled={isJumpPointerDisabled}
      renderUnfurls={() => (
        <CommentViewerUnfurls
          panelId={panelId}
          conversationId={comment.conversationId}
          unfurls={comment.unfurls}
          isInteractionDisabled={isInteractionDisabled}
        />
      )}
    />
  );
};
